import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

import { Form, Container, FormGroup } from "react-bootstrap";

import AuthenticationBgImage from "../../../image/authentication/authentication-background.jpg";

export const StyledAuthenticationSection = styled.section`
  background: url(${AuthenticationBgImage}) no-repeat center;
  background-size: cover;
  padding: 5rem 1rem;
`;

export const StyledContainer = styled(Container)`
  position: relative;
  max-width: ${({ $maxWidth }) => ($maxWidth ? $maxWidth : "680px")};
  min-height: 530px;
  padding: 1rem 2rem 6rem;
  box-shadow: 1px 10px 30px 3px rgba(62, 165, 219, 0.2);
  background-color: var(--white-color);
  border-radius: 18px;
  h1 {
    color: var(--blue-color-dark);
  }
  & .form-group {
    margin-top: 4rem;
  }
`;

export const StyledAuthenticationLogoWrapper = styled.div`
  margin-bottom: 4rem;
`;

export const StyledAuthenticationLogo = styled.img`
  width: 110px;
  margin: 10px auto;
  display: block;
`;

export const StyledForm = styled(Form)`
  transition: all 0.5s ease;
  label {
    color: var(--blue-color-dark);
    font-size: var(--font-size-sm);
  }
  input:not(.OTP-field) {
    height: 46px !important;
    font-size: var(--font-size-xm);
    &[type="password"] {
      font-size: var(--font-size-xxl);
      direction: ltr;
      @media screen and (max-width: 768px) {
        font-size: var(--font-size-base);
      }
    }
    &[type="number"] {
      direction: ltr;
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        appearance: none;
      }
    }
  }

  .form-text.text-danger {
    color: var(--danger-color) !important;
    font-size: var(--font-size-xs);
  }
  .form-text {
    font-size: var(--font-size-xs);
  }
`;

export const StyledFormGroup = styled(FormGroup)`
  .form-control:not(.OTP-field) {
    border-radius: 6px;
    border: 0.5px solid var(--tertiary-color);
  }
  .input-group-eye {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 1rem;
    z-index: 5;
    cursor: pointer;
  }
  .MuiStepLabel-alternativeLabel {
    font-family: iranSans;
    color: var(--blue-color-dark);
  }
`;

const baseStyleOfBackButton = css`
  color: var(--primary-color);
  border: none;
  background-color: #fff;
  position: absolute;
  user-select: none;
`;
export const StyledBackButton = styled.button`
  ${baseStyleOfBackButton};
  top: 2rem;
`;
export const StyledBackLink = styled(Link)`
  top: 2rem;
  ${baseStyleOfBackButton};
`;
